export const RESEARCH_NODES = Object.freeze([
  { id: 'vitality', icon: '🛡️', title: 'เกราะเมฆา', detail: 'HP กองทัพ +6% ต่อระดับ', max: 4, stat: 'hp', step: .06, costs: [1, 2, 3, 4] },
  { id: 'precision', icon: '🎯', title: 'ดวงตาวายุ', detail: 'โอกาสคริติคอล +2% ต่อระดับ', max: 4, stat: 'criticalChance', step: .02, costs: [1, 2, 3, 4] },
  { id: 'fury', icon: '⚔️', title: 'คมดาบวิญญาณ', detail: 'พลังโจมตี +6% ต่อระดับ', max: 4, stat: 'damage', step: .06, costs: [1, 2, 3, 4] },
  { id: 'current', icon: '🌪️', title: 'จังหวะสายลม', detail: 'ความเร็วเคลื่อนที่ +4% ต่อระดับ', max: 4, stat: 'speed', step: .04, costs: [1, 2, 3, 4] },
  { id: 'harvest', icon: '🌾', title: 'พรแห่งผืนฟ้า', detail: 'ผลผลิตเมือง +8% ต่อระดับ', max: 4, stat: 'production', step: .08, costs: [1, 2, 3, 4] },
  { id: 'storage', icon: '🏺', title: 'คลังมิติ', detail: 'ความจุคลัง +10% ต่อระดับ', max: 4, stat: 'storage', step: .10, costs: [1, 2, 3, 4] }
]);

export const EQUIPMENT_ITEMS = Object.freeze([
  { id: 'wind_dagger', model: 'WPN_Dagger_LOD0.glb', kind: 'weapon', icon: '🗡️', title: 'มีดสั้นวายุ', rarity: 'R', type: 'runner', bonus: { speed: .07, criticalChance: .03 } },
  { id: 'sky_bow', model: 'WPN_Bow_LOD0.glb', kind: 'weapon', icon: '🏹', title: 'ธนูท้องนภา', rarity: 'SR', type: 'runner', bonus: { damage: .11 } },
  { id: 'storm_hammer', model: 'WPN_Hammer_LOD0.glb', kind: 'weapon', icon: '🔨', title: 'ค้อนพายุ', rarity: 'SR', type: 'smith', bonus: { damage: .08, hp: .08 } },
  { id: 'guardian_shield', model: 'ARM_Shield_LOD0.glb', kind: 'armor', icon: '🛡️', title: 'โล่ผู้พิทักษ์', rarity: 'R', type: 'smith', bonus: { hp: .14 } },
  { id: 'lotus_staff', model: 'WPN_MagicStaff_LOD0.glb', kind: 'weapon', icon: '🪄', title: 'คทาบัวแก้ว', rarity: 'SR', type: 'lotus', bonus: { hp: .08, healing: .18 } },
  { id: 'spirit_chest', model: 'ARM_Chest_LOD0.glb', kind: 'armor', icon: '🥋', title: 'เกราะวิญญาณ', rarity: 'R', type: 'lotus', bonus: { hp: .12 } },
  { id: 'ember_blade', model: 'WPN_SpiritBlade_LOD0.glb', kind: 'weapon', icon: '🔥', title: 'ดาบเพลิงเมฆา', rarity: 'UR', type: 'ember', bonus: { damage: .16, criticalChance: .04 } },
  { id: 'crossbow', model: 'WPN_Crossbow_LOD0.glb', kind: 'weapon', icon: '🏹', title: 'หน้าไม้จักรกล', rarity: 'R', type: 'ember', bonus: { damage: .09, speed: .04 } }
]);

const bases = [
  [['hall',1,0,1],['mint',1,-5,-2],['timber',1,5,-2]],
  [['hall',2,0,1],['mint',2,-5,-2],['timber',1,5,-2],['arrow',1,0,6]],
  [['hall',2,0,1],['vault',2,0,-5],['arrow',2,-5,4],['arrow',1,5,4]],
  [['hall',3,0,1],['vault',2,0,-5],['arrow',2,-5,4],['bell',2,5,4],['rally',2,-7,-3]],
  [['hall',3,0,1],['dew',2,0,-5],['arrow',3,-6,3],['bell',2,6,3],['workshop',2,0,7]],
  [['hall',4,0,1],['vault',3,0,-6],['guardian',2,-6,3],['bell',3,6,3],['arrow',3,-7,-3],['arrow',3,7,-3]],
  [['hall',4,0,1],['laboratory',3,0,-6],['guardian',3,-6,3],['guardian',2,6,3],['bell',3,0,7]],
  [['hall',5,0,1],['vault',4,0,-6],['guardian',4,-6,3],['guardian',4,6,3],['bell',4,-7,-3],['arrow',4,7,-3],['laboratory',4,0,8]]
];

const stageMeta = [
  ['sky-01','เส้นทางเกาะเริ่มต้น','Sky Village',0,120,'wind_dagger'],
  ['sky-02','ป้อมประตูวายุ','Sky Village',0,180,'guardian_shield'],
  ['mist-01','ซากนครหมอก','Mistwood Ruins',1,260,'spirit_chest'],
  ['mist-boss','ราชาโทรลล์พงหมอก','Mistwood Ruins',1,380,'sky_bow'],
  ['storm-01','แนวป้องกันสายฟ้า','Storm Citadel',2,520,'crossbow'],
  ['storm-boss','วิหารอสนีบาต','Storm Citadel',2,720,'storm_hammer'],
  ['ember-01','เกาะผลึกเพลิง','Volcanic Crystal Isle',3,940,'lotus_staff'],
  ['dragon-boss','มังกรผลึกแห่งเวหา','Volcanic Crystal Isle',3,1300,'ember_blade']
];

function makeBase(rows, biomeIndex, boss = false) {
  return {
    biomeIndex,
    boss,
    buildings: rows.map(([type, level, x, z], index) => ({ id: `stage-${biomeIndex}-${index}`, type, level, x, z })),
    defenses: [
      { type: 'wall', x: -3.4, z: -1.2, rotation: 0 }, { type: 'wall', x: 3.4, z: -1.2, rotation: 0 },
      { type: 'spike', x: -7, z: -6 }, { type: boss ? 'bomb' : 'spike', x: 7, z: -6 }
    ]
  };
}

export const CAMPAIGN_STAGES = Object.freeze(stageMeta.map((meta, index) => {
  const [id, title, biome, biomeIndex, power, equipmentId] = meta;
  const boss = id.includes('boss');
  return {
    id, index, title, biome, biomeIndex, power, boss, equipmentId,
    energy: boss ? 2 : 1,
    reward: { gold: 350 + index * 180, wood: 260 + index * 140, dew: 20 + index * 10, research: boss ? 2 : 1 },
    base: makeBase(bases[index], biomeIndex, boss)
  };
}));

export function adventureDefaults(now = Date.now()) {
  return {
    energy: 5,
    energyDay: new Date(now).toISOString().slice(0, 10),
    stageStars: {},
    firstClear: [],
    researchPoints: 0,
    research: {},
    inventory: [],
    equipped: {},
    replays: [],
    dungeonClaims: {},
    survivalBest: 0
  };
}

export function ensureAdventure(state, now = Date.now()) {
  const defaults = adventureDefaults(now);
  state.adventure = { ...defaults, ...(state.adventure || {}) };
  state.adventure.stageStars = { ...(state.adventure.stageStars || {}) };
  state.adventure.research = { ...(state.adventure.research || {}) };
  state.adventure.inventory = [...new Set(state.adventure.inventory || [])];
  state.adventure.equipped = { ...(state.adventure.equipped || {}) };
  state.adventure.replays = [...(state.adventure.replays || [])].slice(0, 3);
  state.adventure.firstClear = [...new Set(state.adventure.firstClear || [])];
  state.adventure.dungeonClaims = { ...(state.adventure.dungeonClaims || {}) };
  const day = new Date(now).toISOString().slice(0, 10);
  if (state.adventure.energyDay !== day) {
    state.adventure.energyDay = day;
    state.adventure.energy = 5;
    state.adventure.dungeonClaims = {};
  }
  return state.adventure;
}

export function researchBonus(state, stat) {
  const adventure = ensureAdventure(state);
  return RESEARCH_NODES.filter(node => node.stat === stat).reduce((sum, node) => sum + (adventure.research[node.id] || 0) * node.step, 0);
}

export function equipmentBonus(state, type, stat) {
  const adventure = ensureAdventure(state);
  const id = adventure.equipped[type];
  const item = EQUIPMENT_ITEMS.find(entry => entry.id === id);
  return item?.bonus?.[stat] || 0;
}

export function troopAdventureBonuses(state, type) {
  return {
    hp: researchBonus(state, 'hp') + equipmentBonus(state, type, 'hp'),
    damage: researchBonus(state, 'damage') + equipmentBonus(state, type, 'damage'),
    speed: researchBonus(state, 'speed') + equipmentBonus(state, type, 'speed'),
    criticalChance: researchBonus(state, 'criticalChance') + equipmentBonus(state, type, 'criticalChance'),
    healing: equipmentBonus(state, type, 'healing')
  };
}

export function researchNode(state, id) {
  const adventure = ensureAdventure(state);
  const node = RESEARCH_NODES.find(entry => entry.id === id);
  if (!node) return { ok: false, reason: 'ไม่พบงานวิจัยนี้' };
  const level = adventure.research[id] || 0;
  if (level >= node.max) return { ok: false, reason: 'งานวิจัยถึงระดับสูงสุดแล้ว' };
  const cost = node.costs[level];
  if (adventure.researchPoints < cost) return { ok: false, reason: `ต้องใช้แต้มวิจัย ${cost}` };
  adventure.researchPoints -= cost;
  adventure.research[id] = level + 1;
  return { ok: true, node, level: level + 1, cost };
}

export function equipItem(state, id) {
  const adventure = ensureAdventure(state);
  const item = EQUIPMENT_ITEMS.find(entry => entry.id === id);
  if (!item || !adventure.inventory.includes(id)) return { ok: false, reason: 'ยังไม่มีอุปกรณ์นี้' };
  adventure.equipped[item.type] = id;
  return { ok: true, item };
}

export function stageStatus(state) {
  const adventure = ensureAdventure(state);
  return CAMPAIGN_STAGES.map((stage, index) => ({
    ...stage,
    stars: adventure.stageStars[stage.id] || 0,
    unlocked: index === 0 || (adventure.stageStars[CAMPAIGN_STAGES[index - 1].id] || 0) > 0,
    firstCleared: adventure.firstClear.includes(stage.id)
  }));
}

export function beginCampaign(state, id) {
  const stage = stageStatus(state).find(entry => entry.id === id);
  const adventure = ensureAdventure(state);
  if (!stage || !stage.unlocked) return { ok: false, reason: 'ต้องผ่านด่านก่อนหน้า' };
  if (adventure.energy < stage.energy) return { ok: false, reason: 'พลังสำรวจวันนี้หมดแล้ว' };
  adventure.energy -= stage.energy;
  return { ok: true, stage };
}

export function completeCampaign(state, id, marks, percent) {
  const adventure = ensureAdventure(state);
  const stage = CAMPAIGN_STAGES.find(entry => entry.id === id);
  if (!stage) return { ok: false, reason: 'ไม่พบด่าน' };
  const stars = Math.max(0, Math.min(3, Math.floor(marks)));
  adventure.stageStars[id] = Math.max(adventure.stageStars[id] || 0, stars);
  if (stars <= 0) return { ok: true, stage, stars, firstClear: false, reward: {} };
  const firstClear = !adventure.firstClear.includes(id);
  const multiplier = firstClear ? 1 : .2;
  const reward = {
    gold: Math.round(stage.reward.gold * multiplier), wood: Math.round(stage.reward.wood * multiplier),
    dew: Math.round(stage.reward.dew * multiplier), research: firstClear ? stage.reward.research : 0
  };
  state.gold += reward.gold;
  state.spiritWood += reward.wood;
  state.skyDew += reward.dew;
  adventure.researchPoints += reward.research;
  let equipment = null;
  if (firstClear) {
    adventure.firstClear.push(id);
    if (stage.equipmentId && !adventure.inventory.includes(stage.equipmentId)) {
      adventure.inventory.push(stage.equipmentId);
      equipment = EQUIPMENT_ITEMS.find(item => item.id === stage.equipmentId);
    }
  }
  return { ok: true, stage, stars, percent, firstClear, reward, equipment };
}

export function todayDungeon(state, now = Date.now()) {
  const adventure = ensureAdventure(state, now);
  const dayIndex = Math.floor(now / 86400000);
  const stage = CAMPAIGN_STAGES[2 + (dayIndex % 4)];
  const key = new Date(now).toISOString().slice(0, 10);
  return { ...stage, id: `daily-${key}`, sourceStageId: stage.id, title: `รอยแยกรายวัน · ${stage.biome}`, claimed: Boolean(adventure.dungeonClaims[key]), reward: { gold: 900, wood: 700, dew: 90, research: 1 } };
}

export function completeDungeon(state, marks, now = Date.now()) {
  const adventure = ensureAdventure(state, now);
  const dungeon = todayDungeon(state, now);
  const key = new Date(now).toISOString().slice(0, 10);
  if (adventure.dungeonClaims[key]) return { ok: false, reason: 'รับรางวัลรอยแยกวันนี้แล้ว' };
  if (marks <= 0) return { ok: false, reason: 'ต้องทำลายอย่างน้อย 50%' };
  adventure.dungeonClaims[key] = true;
  state.gold += dungeon.reward.gold;
  state.spiritWood += dungeon.reward.wood;
  state.skyDew += dungeon.reward.dew;
  adventure.researchPoints += dungeon.reward.research;
  return { ok: true, dungeon, reward: dungeon.reward };
}

export function storeReplay(state, replay) {
  const adventure = ensureAdventure(state);
  if (!replay?.deployments?.length) return { ok: false };
  const clean = {
    id: `${Date.now()}-${Math.floor(Math.random() * 9999)}`,
    createdAt: Date.now(), enemy: replay.enemy, army: { ...replay.army },
    deployments: replay.deployments.slice(0, 80).map(item => ({ type: item.type, x: Number(item.x.toFixed(2)), z: Number(item.z.toFixed(2)), at: Math.max(0, Math.round(item.at)) })),
    percent: Math.max(0, Math.min(100, replay.percent || 0)), marks: Math.max(0, Math.min(3, replay.marks || 0))
  };
  adventure.replays.unshift(clean);
  adventure.replays = adventure.replays.slice(0, 3);
  return { ok: true, replay: clean };
}

export function sanitizeProgressionState(state) {
  const finite = value => Number.isFinite(Number(value)) ? Math.max(0, Math.floor(Number(value))) : 0;
  state.gold = Math.min(100000000, finite(state.gold));
  state.spiritWood = Math.min(100000000, finite(state.spiritWood));
  state.skyDew = Math.min(10000000, finite(state.skyDew));
  state.summonTickets = Math.min(10000, finite(state.summonTickets));
  for (const type of ['runner', 'smith', 'lotus', 'ember']) state.army[type] = Math.min(1000, finite(state.army[type]));
  ensureAdventure(state);
  return state;
}
